module.exports = __webpack_public_path__ + "static/img/equipment4new.6c56dfb8.png";